var render, staticRenderFns
import script from "./button-base.vue?vue&type=script&lang=js"
export * from "./button-base.vue?vue&type=script&lang=js"
import style0 from "./button-base.vue?vue&type=style&index=0&id=58e41c7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports